
import { defineComponent } from 'vue';
import { RouterLink } from 'vue-router';

export default defineComponent({
    components: {
        RouterLink
    },
    setup () {
        return {
            menus: [
                {
                    path: '/genres',
                    label: '我们关注'
                },
                {
                    path: '/genres/catelog',
                    label: '目录'
                },
                {
                    path: '/meta/albums',
                    label: '专辑列表'
                },
                {
                    path: '/meta/artists',
                    label: '艺人/乐队列表'
                },
                {
                    path: '/meta/search',
                    label: '搜索'
                }
            ]
        };
    }
});

